export default __webpack_public_path__ + "static/media/zero_or_many.d66375a5.gif";